import { useQuery } from "@tanstack/react-query";
import { McpUsageHistoryTable } from "components/McpUsage";
import { Loader } from "components/Loader";
import { getMcpUsageHistory } from "../McpUsage.requests";

const McpUsageHistory = ({ companyId }: { companyId: number }) => {
  const history = useQuery({
    queryKey: ["companyMcpUsageHistory", companyId],
    queryFn: () => getMcpUsageHistory(companyId),
  });

  if (history.isLoading || !history.data) return <Loader />;

  return <McpUsageHistoryTable months={history.data.data} />;
};

export { McpUsageHistory };
